import {
  Activity,
  Box,
  Cloud,
  Database,
  Folder,
  Globe2,
  HardDrive,
  Home,
  Lock,
  Music2,
  Network,
  Rocket,
  Server,
  ShieldCheck,
  Sparkles,
  Terminal,
  Waves,
  Workflow
} from "lucide-react";

type IconGlyphProps = {
  name: string;
  size?: number;
};

const icons = {
  activity: Activity,
  box: Box,
  cloud: Cloud,
  database: Database,
  folder: Folder,
  globe: Globe2,
  "hard-drive": HardDrive,
  home: Home,
  lock: Lock,
  music: Music2,
  network: Network,
  rocket: Rocket,
  server: Server,
  shield: ShieldCheck,
  spark: Sparkles,
  terminal: Terminal,
  waves: Waves,
  workflow: Workflow
};

export function IconGlyph({ name, size = 34 }: IconGlyphProps) {
  const Glyph = icons[name as keyof typeof icons] ?? Globe2;
  return <Glyph size={size} strokeWidth={1.8} aria-hidden="true" />;
}
